import { Card, Stack, Text } from '@mantine/core'
import { motion } from 'framer-motion'
import type { ReactNode } from 'react'

import { sectionCardVariants } from '../animations'

type Props = {
  title: string
  children: ReactNode
  delay?: number
}

// A titled content card with a staggered entrance, shared by the profile pages.
export const SectionCard = ({ title, children, delay = 0 }: Props) => (
  <motion.div
    custom={delay}
    variants={sectionCardVariants}
    initial="hidden"
    animate="visible"
  >
    <Card shadow="sm" padding="xl" radius="lg" withBorder>
      <Stack gap="lg">
        <Text
          fw={700}
          size="sm"
          tt="uppercase"
          c="dimmed"
          style={{ letterSpacing: 0.6 }}
        >
          {title}
        </Text>
        {children}
      </Stack>
    </Card>
  </motion.div>
)
